import { notification as AntdNotification } from "antd"; 
import { NotificationInstance } from "antd/es/notification/interface";

let instance: NotificationInstance;

// 导出一个proxy动态调用api
export const api = new Proxy<NotificationInstance>({} as any, {
  get(target, prop) {
    if (instance) {
      return instance[prop as keyof NotificationInstance];
    }
    return () => {};
  },
});

export function Notification() {
  const [api, contextMsgHolder] = AntdNotification.useNotification();
  instance = api;
  return contextMsgHolder;
}
